import { data } from "react-router-dom";
import { privateRequest } from "../axios";

const ENDPOINTS = {
  OFFER: "/offer",
  OFFER_ID: (id) => `/offer/${id}`,
  UPDATE_STATUS:(id)=>`/offer/update-status/${id}`
};

const getOffers = async (params) => {
  const response = await privateRequest.get(ENDPOINTS.OFFER, { params });
  return response?.data;
};

const getOfferById = async (id) => {
  const response = await privateRequest.get(ENDPOINTS.OFFER_ID(id));
  return response?.data;
};

const addOffer = async (data) => {
  const response = await privateRequest.post(ENDPOINTS.OFFER, data);
  return response?.data;
};

const updateOffer = async (id, data) => {
  const response = await privateRequest.put(ENDPOINTS.OFFER_ID(id), data);
  return response?.data;
};

const updateOfferStatus = async(id,data)=>{
  const response = await privateRequest.post(ENDPOINTS.UPDATE_STATUS(id),data);
  return response?.data
}
const deleteOffer = async (id) => {
  const response = await privateRequest.delete(ENDPOINTS.OFFER_ID(id));
  return response?.data;
};

const OfferService = {
  getOffers,
  getOfferById,
  addOffer,
  updateOffer,
  updateOfferStatus,
  deleteOffer,
};

export default OfferService;
